export default __webpack_public_path__ + "static/media/gio_avatar.236f1201.png";